import { render, staticRenderFns } from "./orgcompanydiscount.vue?vue&type=template&id=0da89013&"
import script from "./orgcompanydiscount.vue?vue&type=script&lang=js&"
export * from "./orgcompanydiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports